import TypeSearch from './src/main';

/* istanbul ignore next */
TypeSearch.install = function(Vue) {
  Vue.component(TypeSearch.name, TypeSearch);
};

export default TypeSearch;
